import React from 'react'

function Information() {
  return (
    <>
    <section class="projects-section bg-light" id="Info">
            <div class="container px-4 px-lg-5">
                {/* <!-- Featured Project Row--> */}
                <div class="row gx-0 mb-4 mb-lg-5 align-items-center">
                    <div class="col-xl-1 col-lg-7"></div>
                    <div class="col-xl-4 col-lg-5">
                        <div class="featured-text text-center text-lg-left">
                            <h4>Informations</h4>
                            <p class="text-black-50 mb-0">เรามีจุดถ่ายรูปทั้ง Indoor และ outdoor และ มีกิจกรรมต่างๆ</p>
                        </div>
                    </div>
                </div>
                {/* <!-- Project One Row--> */}
                <div class="row gx-0 mb-5 mb-lg-0 justify-content-center">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/view/p7.jpg" alt="..." /></div>
                    <div class="col-lg-6">
                        <div class="bg-black text-center h-100 project">
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-left">
                                    <h4 class="text-white">ขนมเบเกอรี่รายวัน</h4>
                                    <p class="mb-0 text-white-50">"ขนมเค้ก พาย และเบเกอรี่ต่างๆ ที่ทางร้านจะทำขึ้นใหม่ในทุกๆวัน"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Project Two Row--> */}
                <div class="row gx-0 justify-content-center">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/view/p1.jpg" alt="..." /></div>
                    <div class="col-lg-6 order-lg-first">
                        <div class="bg-black text-center h-100 project">
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-right">
                                    <h4 class="text-white">ทุ่งนาตามฤดู</h4>
                                    <p class="mb-0 text-white-50">"เราทีวิวทุ่งนาที่จะสวยงามตามฤดูกาล"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row gx-0 mb-5 mb-lg-0 justify-content-center">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/view/p3.jpg" alt="..." /></div>
                    <div class="col-lg-6">
                        <div class="bg-black text-center h-100 project">
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-left">
                                    <h4 class="text-white">รถไฟสายสีฟ้า</h4>
                                    <p class="mb-0 text-white-50">"รถไฟสายนี้จะพาคุณแล่นผ่านทุ่งนา รับกลิ่นดิน กลิ่นทุ่งนา รับแสงแดด และบรรยากาศดีดี"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Project Two Row--> */}
                <div class="row gx-0 justify-content-center">
                    <div class="col-lg-6"><img class="img-fluid" src="assets/img/view/p6.jpg" alt="..." /></div>
                    <div class="col-lg-6 order-lg-first">
                        <div class="bg-black text-center h-100 project">
                            <div class="d-flex h-100">
                                <div class="project-text w-100 my-auto text-center text-lg-right">
                                    <h4 class="text-white">สะพาน Check-In</h4>
                                    <p class="mb-0 text-white-50">"สามารถเดินชมวิวในสวน พร้อมทั้งให้อาหารปลา"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Information